<!--<app-sign-task-details-->
<!--    *ngIf="isDetailsOpen"-->
<!--    [processId]="detailsPageProcessId">-->
<!--</app-sign-task-details>-->
<div class="relative">
    <app-temporary-sign-task-details
        id="detailsPage"
        class="translate-x-100 custom-dynamic-sidebar"
        [processId]="detailsPageProcessId"
        (closeDetailsEventEmitter)="receiveDetailsPageClose($event)"
        *ngIf="isDetailsOpen">
    </app-temporary-sign-task-details>
</div>

<div>
    <h2 class="margin-left-2rem">{{ 'sipo.document-process' | translate }}</h2>
    <p-table [value]="signingProcessList" dataKey="id"
             [tableStyle]="{ 'min-width': '60rem', 'padding':'2rem', 'border':'none' }"
             [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)"
             (onRowCollapse)="onRowCollapse($event)">
        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th class="w-9rem" pSortableColumn="signType">{{ 'sipo.signature' | translate }}
                    <p-sortIcon field="signType"/>
                </th>
                <th class="w-8rem" pSortableColumn="name">{{ 'sipo.user' | translate }}
                    <p-sortIcon field="name"/>
                </th>
                <th pSortableColumn="timestamp">{{ 'sipo.creation-date' | translate }}
                    <p-sortIcon field="timestamp"/>
                </th>
                <th pSortableColumn="finalizedDate">{{ 'sipo.finalized-date' | translate }}
                    <p-sortIcon field="finalizedDate"/>
                </th>
                <th pSortableColumn="status">{{ 'sipo.status' | translate }}
                    <p-sortIcon field="status"/>
                </th>
                <th pSortableColumn="orgfile">{{ 'sipo.original-document' | translate }}</th>
                <th pSortableColumn="signedfile">{{ 'sipo.signed-document' | translate }}</th>
                <th pSortableColumn="details"></th>
                <th pSortableColumn="delete"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-expanded="expanded">
            <tr>
                <td>
                    <p-button type="button" pRipple [pRowToggler]="product" [text]="true" [rounded]="false"
                              styleClass="border-radius: 15px !important; "
                              [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"/>
                </td>
                <td>
                    <div class="w-6rem" [innerHTML]="product?.signType | evidenceSvg"></div>
                </td>
                <td>{{ product.user }}</td>
                <td>{{ product.timestamp | dateTime }}</td>
                <td>
                    <div *ngIf="product.status==='finished'">{{ product.finalizedDate | dateTime }}</div>
                </td>
                <td>
                    <p-tag *ngIf="!product.draft" [value]="getStatusText(product.status)"
                           [severity]="getStatus(product.status)"/>
                    <p-tag *ngIf="product.draft" [value]="getStatusText('draft')" [severity]="getStatus('info')"/>
                </td>
                <td style="max-width: 15rem;">
                    <a (click)="downloadFile(product.id, 'unsigned', product.fileName)"
                       class="cursor-pointer show-as-link no-line-breaks"
                       title="{{ product.fileName ? product.fileName : 'orginal file' }}">{{ product.fileName ? product.fileName : 'orginal file' }}</a>
                </td>
                <td style="max-width: 15rem;">
                    <a *ngIf="product.status==='finished'" class="cursor-pointer show-as-link  no-line-breaks"
                       (click)="downloadFile(product.id, 'signed', product.fileName)"
                       title="{{ product.fileName ? (product.fileName | signedFileName) : 'orginal file' }}">{{ product.fileName ? (product.fileName | signedFileName) : 'orginal file' }}</a>
                </td>
                <td>
                    <i *ngIf="!product.draft" class="pi pi-info-circle cursor-pointer text-3xl text-color-default" (click)="getDetails(product.id)" [title]="'sipo.details' | translate "></i>
<!--                    <p-button *ngIf="!product.draft"-->
<!--                              class="width-12rem"-->
<!--                              (click)="getDetails(product.id)">-->
<!--                        <span>{{ 'sipo.details' | translate }}</span>-->
<!--                    </p-button>-->

                    <i *ngIf="product.draft" class="pi pi-forward cursor-pointer text-3xl text-color-default" (click)="openSignDialogForEditing(product.id)" [title]="'sipo.continue' | translate "></i>
<!--                    <p-button *ngIf="product.draft"-->
<!--                              class="width-12rem"-->
<!--                              (click)="openSignDialogForEditing(product.id)">-->
<!--                        <span>{{ 'sipo.continue' | translate }}</span>-->
<!--                    </p-button>-->
                </td>
                <td>
                    <i class="pi pi-trash cursor-pointer text-3xl text-color-red" (click)="deleteItem(product.id, product?.signType)" [title]="'sipo.delete' | translate "></i>
<!--                    <p-button severity="danger"-->
<!--                              class="p-button-danger border-none bg-transparent text-blue-400 hover:text-blue-800 cursor-pointer width-12rem"-->
<!--                              (click)="deleteItem(product.id, product?.signType)">-->
<!--                        <span>{{ 'sipo.delete' | translate }}</span>-->
<!--                    </p-button>-->
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-product>
            <tr>
                <td colspan="10" class="px-3 py-3 w-full" *ngIf="isProductSubItemsLoading">
                    <p-progressSpinner></p-progressSpinner>
                </td>
                <td colspan="10" class="px-3 py-1" *ngIf="!isProductSubItemsLoading">
                    <div>
                        <h6 class="margin-left">{{ 'sipo.signers' | translate }}</h6>
                        <p-table [value]="product.subItems" dataKey="id"
                                 class="margin-left subtable subtable-table-color">
                            <ng-template pTemplate="header">
                                <tr>

                                    <th pSortableColumn="email">{{ 'sipo.email' | translate }}
                                        <p-sortIcon field="email"/>
                                    </th>
                                    <th pSortableColumn="name">{{ 'sipo.name' | translate }}
                                        <p-sortIcon field="name"/>
                                    </th>
                                    <th pSortableColumn="date">{{ 'sipo.sent-date' | translate }}
                                        <p-sortIcon field="date"/>
                                    </th>
                                    <th pSortableColumn="date">{{ 'sipo.signed-date' | translate }}
                                        <p-sortIcon field="date"/>
                                    </th>
                                    <th pSortableColumn="status">{{ 'sipo.status' | translate }}
                                        <p-sortIcon field="status"/>
                                    </th>
                                    <th style="width: 20rem">{{ 'sipo.signed-document' | translate }}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-order>
                                <tr>
                                    <td>{{ order.email }}</td>
                                    <td>{{ order.name }}</td>
                                    <td>{{ order.timestamp  | dateTime }}</td>
                                    <td>
                                        <div *ngIf="order.status==='finished'">{{ order.date  | dateTime }}</div>
                                    </td>
                                    <td>
                                        <p-tag [value]="getStatusText(order.status)"
                                               [severity]="getStatus(order.status)"/>
                                        <!--
                                        <button  *ngIf="order.status =='created'" class="border-0 bg-transparent shadow-none ml-1 text-red-500">
                                            <i class="pi pi-bell"></i>
                                        </button>
                                        -->
                                    </td>
                                    <td>

                                        <a *ngIf="order.status==='finished'"
                                           (click)="downloadWorkflowFile(order.id, 'signed', product.fileName)"
                                           class="cursor-pointer show-as-link  no-line-breaks"
                                           title="{{ product.fileName ? product.fileName : 'orginal file' }}">{{ product.fileName ? product.fileName : 'orginal file' }}</a>


                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="6">{{'sipo.no-documents-to-sign' | translate}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
